import { createAction, props } from '@ngrx/store';

export const editAlarmSuccess = createAction('[Alarm] Edit Alarm Success', props<{ alarmData: any }>());
export const loadAssetById = createAction('[Alarm] Load Asset By Id', props<{ assetData: string }>());


export const clearEditAlarm = createAction('[Alarm] Edit Clear');
export const clearAssetById = createAction('[Alarm] Clear Asset By Id Clear');